import moment from 'moment'
import { get } from 'lodash'

export default {
  prepareShow (upcoming) {
    upcoming.time = moment(upcoming.date).format('HH:mm')
    upcoming.date = moment(upcoming.date).format('DD/MM')
    upcoming.covenant = get(upcoming, 'covenant.name', 'Particular')
    upcoming.speciality = get(upcoming, 'speciality.name', 'Não especificado')
    upcoming.degree = get(upcoming, 'patient.degree.name', null)

    return upcoming
  },
  setSchedule (schedule) {
    this.currentSchedule = schedule
    this.showModal = true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/resources/methods.js